<template>
<div>
  <div class="columns">
    <div class="column">
      <h3 class="title">Scrapers</h3>
    </div>
    <div class="column is-narrow">
      <router-link 
        class="button is-small"
        :to="{
          name: 'create-scraper',
          query: {
            builder: 'attribute',
            type: attributeType.id,
          }
        }">
        Create Scraper
      </router-link>
    </div>
  </div>

  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Scraper</th>
        <th>Payload</th>
        <th class="has-text-right">Secondary Scrapers</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="scraper in attributeType.scrapers" :key="scraper.id">
        <td>{{ scraper.scraper.name }}</td>
        <td>{{ scraper.payload }}</td>
        <td class="has-text-right">
          <router-link
            :to="{
              name: 'attribute-type-scraper-secondary-scrapers',
              params: {
                attributeType: attributeType.id,
                scraper: scraper.id,
              }
            }">
            {{ scraper.secondary_scrapers.length }}
          </router-link>
        </td>
        <td class="is-narrow has-text-right">
          <action-button @click="deleteScraper(scraper)" class="is-small is-danger">
            <icon icon="trash"/>
          </action-button>
        </td>
      </tr>
    </tbody>
  </table>

  <p class="has-text-centered" v-if="!attributeType.scrapers.length">This attribute type does not have any scrapers assigned.</p>
  <!-- <div v-if="attributeType.scrapers.length">
    <div class="columns">
      <div class="column">
        <div class="box">
          <h5 class="title is-5">Scraping Payload</h5>
          <div class="is-flex space-between" v-if="!payloadIsComplex">
            <p>{{ attributeType.scraper_payload }}</p>
            <raw-scrape-type :type="attributeType.raw_scrape_type"/>
          </div>
          <div v-else>
            <div class="columns">
              <div class="column is-6">
                <p class="is-flex justify-between" v-for="(payload, type) in attributeType.scraper_payload" :key="type">
                  <span class="has-text-weight-bold has-text-danger">{{ type }}</span>
                  <span>{{ payload }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-narrow">
        <action-button @click="deleteScraper">Delete</action-button>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="box">

          <primary-scraper-overview :scraper="scraper"/>

          <hr>

          <div class="columns">
            <div class="column">
              <div class="columns">
                <div class="column">
                  <p class="has-text-weight-bold">Secondary Scrapers ({{ attributeType.secondary_scrapers.length }})</p>
                </div>
                <div class="column is-narrow">
                  <router-link :to="{
                    name: 'attribute-type-create-secondary-scraper',
                    params: {
                      attributeType: attributeType.id
                    }}" 
                    class="is-small is-rounded button">
                    <icon icon="plus"/>
                    <span>Secondary Scraper</span>
                  </router-link>
                </div>
              </div>
              <div v-for="(scraper, index) in attributeType.secondary_scrapers" :key="scraper.id">

                <source-scraper-overview 
                  v-if="scraper.type === 'source'"
                  :scraper="scraper"
                  :index="++index"/>
                
                <general-secondary-scraper-overview
                  v-if="scraper.type === 'attribute'"
                  :scraper="scraper"
                  :index="++index"/>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>

  </div> -->

</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import PrimaryScraperOverview from './partials/PrimaryScraperOverview.vue'
import SourceScraperOverview from './partials/SourceScraperOverview.vue'
import GeneralSecondaryScraperOverview from './partials/GeneralSecondaryScraperOverview.vue'

export default {

  components: {
    PrimaryScraperOverview,
    SourceScraperOverview,
    GeneralSecondaryScraperOverview
  },
  
  beforeCreate() {
    this.$store.dispatch('attributeType/loadAttributeType', this.$route.params.attributeType)
  },

  methods: {
    async deleteScraper(scraper) {
      if(await this.$confirm({
        title: 'Delete Scraper',
        message: 'By deleting this scraper you will also be deleting any secondary scrapers associated with this scraper.'
      })) {
        this.$store.dispatch('attributeType/deleteScraper', scraper.id).then(() => {
          this.$toast.success('Scraper Removed')
        }).catch(error => {
          this.$toast.error('Whoops please try again')
        })
      }
    }
  },

  computed: {
    ...mapGetters('attributeType', [
      'attributeType'
    ]),
    payloadIsComplex() {
      return this.attributeType.scraper_payload instanceof Object
    }
  }

}
</script>